import { Injectable, TemplateRef, ViewContainerRef } from '@angular/core';
import { MatDrawerToggleResult, MatSidenav } from '@angular/material/sidenav';

/**
 * The `SidenavService` is used to create a embedded view inside a `ProjectTrackerSidenavContainerComponent` container.
 * @see ProjectTrackerSidenavContainerComponent
 */
@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  private panel: MatSidenav;
  private vcf: ViewContainerRef;

  setPanel(sidenav: MatSidenav): void {
    this.panel = sidenav;
  }

  setContentVcf(viewContainerRef: ViewContainerRef): void {
    this.vcf = viewContainerRef;
  }

  private createView(template: TemplateRef<any>): void {
    this.vcf.clear();
    this.vcf.createEmbeddedView(template);
  }

  open(template: TemplateRef<any>): Promise<MatDrawerToggleResult> {
    this.createView(template);
    return this.panel.open();
  }

  close(): Promise<MatDrawerToggleResult> {
    return this.panel.close();
  }

  toggle(): Promise<MatDrawerToggleResult> {
    return this.panel.toggle();
  }
}
